import { useState } from "react";
import { UserOption } from "./formatTemplate";
import { httpClient } from "../api/client";
import { logger } from "@/helpers/tslog";

export default function useFetchUsers(searchQuery: string = "") {
  const [userOptions, setUserOptions] = useState<UserOption[]>([]);

  async function fetchUsers(email: string = searchQuery) {
    try {
      const response = await httpClient.get("/org/user", {
        params: {
          email,
          limit: 10,
        },
      });

      const fetchedUsers: UserOption[] = response.data.map((user: { email: string }) => ({
        label: user.email,
        value: user.email,
      }));

      setUserOptions(fetchedUsers);
    } catch (err) {
      logger.error("Error fetching users:", err);
    }
  }

  return { userOptions, fetchUsers };
}